// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barChart_container__f3-3G {
  padding: 10px; }

.barChart_tooltip__DGbO2 {
  background: var(--White);
  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
  border-radius: 4px;
  width: 240px;
  height: 139px; }

.barChart_header__4ebuO {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: var(--HightEmphasis); }

.barChart_time__rJol7 {
  color: var(--LowEmphasis);
  margin-left: 5px; }

.barChart_stockNumber__uf2PA {
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.03em;
  margin-right: 5px; }

.barChart_stockIn__nWf2D {
  color: var(--Green); }

.barChart_low__s\\+\\+Tr {
  color: var(--StockOrange); }

.barChart_out__mSNL0 {
  color: var(--StockRed); }

.barChart_stock__Yzkmb {
  display: flex;
  align-items: baseline; }

.barChart_status__92Y0c {
  margin-top: 10px;
  letter-spacing: 0.1px;
  color: var(--White);
  border-radius: 20px;
  padding: 0px 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  width: fit-content; }

.barChart_statusStock__UhY4E {
  background-color: var(--Green); }

.barChart_statusLowStock__AGw-Y {
  background-color: var(--StockOrange); }

.barChart_statusOutStock__DrSPw {
  background-color: var(--StockRed); }

.barChart_click__2FmGZ {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: var(--LowEmphasis);
  margin-top: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/BarChart/barChart.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa,EAAA;;AAGf;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;EACZ,aAAa,EAAA;;AAGf;ECsBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDtBjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EAEtB,2BAA2B,EAAA;;AAG7B;EACE,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EC5BE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;ED4BjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EAEtB,iBAAiB,EAAA;;AAGnB;EACE,mBAAmB,EAAA;;AAGrB;EACE,yBAAyB,EAAA;;AAG3B;EACE,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,qBAAqB,EAAA;;AAGvB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;ECjBjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDiBjB,kBAAkB,EAAA;;AAGpB;EACE,8BAA8B,EAAA;;AAGhC;EACE,oCAAoC,EAAA;;AAGtC;EACE,iCAAiC,EAAA;;AAEnC;ECjCE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDiCjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.container {\n  padding: 10px;\n}\n\n.tooltip {\n  background: var(--White);\n  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n  border-radius: 4px;\n  width: 240px;\n  height: 139px;\n}\n\n.header {\n  @include body1;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.15px;\n\n  color: var(--HightEmphasis);\n}\n\n.time {\n  color: var(--LowEmphasis);\n  margin-left: 5px;\n}\n\n.stockNumber {\n  @include h1;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.03em;\n\n  margin-right: 5px;\n}\n\n.stockIn {\n  color: var(--Green);\n}\n\n.low {\n  color: var(--StockOrange);\n}\n\n.out {\n  color: var(--StockRed);\n}\n\n.stock {\n  display: flex;\n  align-items: baseline;\n}\n\n.status {\n  margin-top: 10px;\n  letter-spacing: 0.1px;\n  color: var(--White);\n  border-radius: 20px;\n  padding: 0px 10px;\n  @include body2;\n  width: fit-content;\n}\n\n.statusStock {\n  background-color: var(--Green);\n}\n\n.statusLowStock {\n  background-color: var(--StockOrange);\n}\n\n.statusOutStock {\n  background-color: var(--StockRed);\n}\n.click {\n  @include body2;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: var(--LowEmphasis);\n  margin-top: 20px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `barChart_container__f3-3G`,
	"tooltip": `barChart_tooltip__DGbO2`,
	"header": `barChart_header__4ebuO`,
	"time": `barChart_time__rJol7`,
	"stockNumber": `barChart_stockNumber__uf2PA`,
	"stockIn": `barChart_stockIn__nWf2D`,
	"low": `barChart_low__s++Tr`,
	"out": `barChart_out__mSNL0`,
	"stock": `barChart_stock__Yzkmb`,
	"status": `barChart_status__92Y0c`,
	"statusStock": `barChart_statusStock__UhY4E`,
	"statusLowStock": `barChart_statusLowStock__AGw-Y`,
	"statusOutStock": `barChart_statusOutStock__DrSPw`,
	"click": `barChart_click__2FmGZ`
};
export default ___CSS_LOADER_EXPORT___;
